import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row gt-sm" }
const _hoisted_2 = { class: "col no-padding" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"30px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)
const _hoisted_4 = { class: "row reverse-wrap q-pt-md items-center justify-evenly" }
const _hoisted_5 = {
  class: "q-mt-lg col-xl-6 col-lg-6 col-md-7 col-sm-12 col-xs-12",
  style: {"height":"100%"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_8 = { class: "text-primary text-h4 q-my-md q-mx-xs" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"30px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)
const _hoisted_10 = { class: "row q-pt-md" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "column" }
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BigCard = _resolveComponent("BigCard")!
  const _component_GreenTitle = _resolveComponent("GreenTitle")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_RegisterForm = _resolveComponent("RegisterForm")!
  const _component_ForgotForm = _resolveComponent("ForgotForm")!
  const _component_MainContent = _resolveComponent("MainContent")!

  return (_openBlock(), _createBlock(_component_MainContent, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_BigCard, {
            title: _ctx.$t('Login.PresentationSection.Title'),
            desc: _ctx.$t('Login.PresentationSection.Resume'),
            url: "product-intrafix.jpg"
          }, null, 8, ["title", "desc"])
        ])
      ]),
      _hoisted_3,
      _createVNode(_component_GreenTitle, {
        title: _ctx.$t('Login.LoginSection.Title')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock("video", {
            autoplay: "",
            loop: "",
            muted: "",
            key: _ctx.$i18n.locale
          }, [
            _createElementVNode("source", {
              src: `videos/intro_pharmacist_website_${_ctx.$i18n.locale === 'de' ? 'DE' : 'FR'}.mp4`,
              type: "video/mp4"
            }, null, 8, _hoisted_6)
          ]))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.headerTitle), 1),
          _createVNode(_component_q_separator, { class: "bg-lightgrey q-mb-lg" }),
          (!_ctx.showRegister && !_ctx.showForgot)
            ? (_openBlock(), _createBlock(_component_LoginForm, {
                key: 0,
                onToggleShowRegister: _ctx.toggleShowRegister,
                onToggleShowForgot: _ctx.toggleShowForgot,
                registered: _ctx.registered || _ctx.mailSent
              }, null, 8, ["onToggleShowRegister", "onToggleShowForgot", "registered"]))
            : _createCommentVNode("", true),
          (_ctx.showRegister)
            ? (_openBlock(), _createBlock(_component_RegisterForm, {
                key: 1,
                onToggleShowRegister: _ctx.toggleShowRegister,
                onRegistered: _ctx.setRegistered
              }, null, 8, ["onToggleShowRegister", "onRegistered"]))
            : _createCommentVNode("", true),
          (_ctx.showForgot)
            ? (_openBlock(), _createBlock(_component_ForgotForm, {
                key: 2,
                onToggleShowForgot: _ctx.toggleShowForgot,
                onMailSent: _ctx.setMailSent
              }, null, 8, ["onToggleShowForgot", "onMailSent"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_9,
      _createVNode(_component_GreenTitle, {
        title: _ctx.$t('Disclaimer.Title')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "col",
              innerHTML: _ctx.$t('Disclaimer.Text')
            }, null, 8, _hoisted_13)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}